import { types } from '../constants'

const index = {
  pending: `${types.list}_PENDING`,
  fulfilled: `${types.list}_FULFILLED`,
  rejected: `${types.list}_REJECTED`,
  setPage: types.page,
  setPerPage: types.perPage
}

export const list = {
  [index.pending]: ({ draft }) => {
    draft.campaign.list.loading = true
    draft.campaign.list.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.campaign.list.data = action.payload
    draft.campaign.list.loading = false
    draft.campaign.list.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.campaign.list.loading = false
    draft.campaign.list.error = action.payload
  },
  [index.setPage]: ({ draft, action }) => {
    draft.campaign.list.page = action.payload
  },
  [index.setPerPage]: ({ draft, action }) => {
    draft.campaign.list.perPage = action.payload
  }
}
